import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 436",
  "use": "icon-Path 436-usage",
  "viewBox": "0 0 29.007 18.398",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29.007 18.398\" id=\"icon-Path 436\">\n  <path id=\"icon-Path 436_Path_436\" data-name=\"Path 436\" d=\"M557.7,511.5a9.094,9.094,0,0,1,8.8-9.2,8.938,8.938,0,0,1,6.6,2.3c-.8.8-1.5,1.7-2.3,2.4a6.747,6.747,0,0,0-5.5-1.1,5.9,5.9,0,0,0-3.8,7.5,5.806,5.806,0,0,0,7.7,3.5,5.251,5.251,0,0,0,3-3.5c-1.8,0-3.5,0-5.3-.1v-3.2h8.9a10.272,10.272,0,0,1-1.9,7.4c-2.3,3-6.5,3.8-10,2.7a8.945,8.945,0,0,1-6.2-8.7Zm23.8-3.9h2.6v2.6h2.6v2.6h-2.6v2.6h-2.6v-2.6h-2.6v-2.6h2.6Z\" transform=\"translate(-557.693 -502.272)\" fill=\"#fff\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 436.svg
// module id = E+/Q
// module chunks = 3